export default {
    title: `En cours...`,
    text: `Nous sommes en train d'agréger vos données, en attendant, vous pouvez compléter votre profil`,
    button: `Compléter votre profil`,
};
